import { render } from "./VacancyForm.vue?vue&type=template&id=ff0b3460&scoped=true"
import script from "./VacancyForm.vue?vue&type=script&lang=js"
export * from "./VacancyForm.vue?vue&type=script&lang=js"

import "./VacancyForm.vue?vue&type=style&index=0&id=ff0b3460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0b3460"]])

export default __exports__